import React from "react";
import { Button } from "@mui/material";
import "./view-assignment.css";
import DownladIcon from "./../../../assets/svg/download.svg";
import { SideMenu, BackHeader } from "./../../components";
import { useNavigate } from "react-router-dom";
let ViewAssignment = (props) => {
  const navigate = useNavigate();
  return (
    <SideMenu>
      <div className="page-container">
        <BackHeader backHanler={() => navigate(-1)} />
        <div className="view-assignment-data-main">
          <p className="view-assignment-title">Student Name: </p>
          <p className="view-assignment-description">Willow Anderson</p>
        </div>
        <div className="view-assignment-data-main">
          <p className="view-assignment-title">Class and Division:</p>
          <p className="view-assignment-description">Class 5th A</p>
        </div>
        <div className="view-assignment-data-main">
          <p className="view-assignment-title">Date:</p>
          <p className="view-assignment-description">03-03-2022</p>
        </div>
        <div className="view-assignment-data-main">
          <p className="view-assignment-title">Task name:</p>
          <p className="view-assignment-description">
            Nam ac velit eu magna placerat mattis sit amet et velit. Cras
            eleifend ante id aliquam sagittis.
          </p>
        </div>
        <div className="view-assignment-data-main">
          <p className="view-assignment-title">Task Description</p>
        </div>
        <p className="view-assignment-description">
          Nam ac velit eu magna placerat mattis sit amet et velit. Cras eleifend
          ante id aliquam sagittis. Curabitur vitae neque neque. Phasellus et
          feugiat ex. Aenean ultricies est ut dignissim varius. Ut quis lacus
          auctor, faucibus neque scelerisque, tempus nunc. Maecenas consectetur
          purus sit amet nisl pharetra varius. Ut malesuada scelerisque purus,
          quis luctus dolor consectetur vel. Mauris lacinia neque ac ullamcorper
          scelerisque. Vestibulum elementum iaculis ex id ultricies. Phasellus a
          justo dolor. Sed quis ex nec risus mattis volutpat.
        </p>
        <br />
        <br />
        <Button>
          <img src={DownladIcon} />
        </Button>
      </div>
    </SideMenu>
  );
};
export default ViewAssignment;
